import { css } from '@emotion/react'

export const wrapperStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${theme.spacings.tera};
`

export const verticalCenterStyles = () => css`
  display: flex;
  align-items: center;
`

export const titleStyles = ({ theme }) => css`
  display: block;
  margin: 0;
  color: ${theme.colors.n800};
  font-size: 18px;
  font-weight: ${theme.font.weight.semibold};
  text-align: left;
`

export const textStyles = ({ theme }) => css`
  display: block;
  margin-top: ${theme.spacings.byte};
  margin-bottom: 0;
  color: ${theme.colors.n400};
  font-size: 12px;
  line-height: 14px;
  text-align: left;

  svg {
    display: block;
    margin-right: ${theme.spacings.byte};
  }
`
